'use client';

import { PageLegalSchema } from '@/sanity/pages/PageLegalTemplate';
import Footer from '../global/partials/Footer';
import { PortableText } from 'next-sanity';
import { richTextComponent } from '@/sanity/sanityPortableText';
import Logo from '../global/Logo';
import Link from 'next/link';
import { motion } from 'framer-motion';
import Header from '../global/partials/Header';

export default function PageLegalJSX({ data }: { data: PageLegalSchema }) {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: [0.76, 0, 0.24, 1],
      },
    },
  };

  return (
    <main>
      {data?.settings?.header && (
        <Header
          headerData={data?.settings?.header}
        />
      )}

      <motion.div
        className="container max-w-[130rem] mx-auto flex flex-col gap-[3rem] lg:gap-[5rem] pointer-events-none lg:pt-[22rem] pt-[18rem] pb-[10.5rem]"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: '-100px' }}
        variants={containerVariants}
      >
        {data?.content?.name && (
          <p className="font-nunito text-[5.65rem] lg:text-[7.5rem] text-fakeblack leading-[120%]">{data?.content?.name}</p>
        )}

        {data?.content?.text && (
          <motion.div
            className="flex flex-col pointer-events-auto
             prose-headings:text-fakeblack prose-h3:text-[3rem] prose-h3:mb-[2rem] prose-h3:font-[400]
             prose-h4:text-[2rem] lg:prose-h4:text-[2.5rem] prose-h4:mb-[1.5rem] prose-h4:font-[400] lg:prose-h4:font-[300]
             prose-p:text-fakeblack prose-p:text-[1.75rem] lg:prose-p:text-[2rem] prose-p:mb-[2rem]"
            variants={itemVariants}
          >
            <PortableText value={data?.content?.text} components={richTextComponent} />
          </motion.div>
        )}
      </motion.div>

      {data?.settings?.footer && <Footer data={data?.settings?.footer} />}
    </main>
  );
}
